import { useMemo } from "react";

import { useAllCareerLevels } from "~/modules/humanResources/api/careerLevel/careerLevelQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { getInputDefaultOptionsData, mapDataToInputOptionsData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


const useCareerLevelOptions = (includeCtaOption: boolean = false): FormInputOption[] => {
	const { data: careerLevelData } = useAllCareerLevels();
	return useMemo(() => {
		if (careerLevelData) {
			const careerLevelDataSorted = [...careerLevelData].sort(byObjectProperty("displayName"));
			const options = mapDataToInputOptionsData(careerLevelDataSorted, "id", "displayName");

			if (includeCtaOption) {
				return [getInputDefaultOptionsData(), ...options];
			}
			return options;
		}
		return [];
	}, [careerLevelData, includeCtaOption]);
};

export default useCareerLevelOptions;

